const orderKey = 'ORDER';
const pcKey = 'PC';
const tabletKey = 'TABLET';
const mobileKey = 'TABLET';
const seoSetting = 'SEO_SETTING';
const pageSetting = 'PAGE_SETTINGs';
const seoSettingKey = {
  description: 'description',
  favicon: 'favicon',
  title: 'title',
};

export {
  orderKey,
  pcKey,
  tabletKey,
  mobileKey,
  seoSetting,
  seoSettingKey,
  pageSetting,
};
